import React, { useState, useEffect } from "react";

const CustomSelect = ({
  label,
  options = [],
  labelKey = "name",
  onSelect,
  value,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  useEffect(() => {
    // Si value tiene un id o nombre, lo mostramos
    if (value && (value.id || value[labelKey])) {
      const selected = options.find((opt) => opt.id === value.id);
      setInputValue(selected ? selected[labelKey] : (value[labelKey] || ""));
    } else {
      setInputValue("");
    }
  }, [value, options, labelKey]);

  // MODIFICACIÓN AQUÍ:
  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);

    // Si el usuario borra el contenido del input
    if (val.trim() === "") {
      onSelect && onSelect(null); // Notificamos al padre que se borró la selección
    }

    setFilteredOptions(
      options.filter((opt) =>
        opt[labelKey].toLowerCase().includes(val.toLowerCase())
      )
    );
    setShowOptions(true);
  };

  const handleSelect = (item) => {
    setInputValue(item[labelKey]);
    setShowOptions(false);
    onSelect && onSelect(item);
  };

  return (
    <div className="position-relative">
      {label && <label>{label}</label>}
      <input
        className="form-control"
        value={inputValue}
        onChange={handleChange}
        onFocus={() => setShowOptions(true)}
        // Aumentamos un poco el tiempo para asegurar que el click en la lista registre
        onBlur={() => setTimeout(() => setShowOptions(false), 200)} 
        placeholder="Selecciona una opción"
      />
      {showOptions && (
        <ul
          className="list-group position-absolute w-100"
          style={{ zIndex: 1000, maxHeight: 200, overflowY: "auto" }}
        >
          {filteredOptions.length ? (
            filteredOptions.map((opt) => (
              <li
                key={opt.id}
                className="list-group-item list-group-item-action"
                onClick={() => handleSelect(opt)}
                style={{ cursor: "pointer" }}
              >
                {opt[labelKey]}
              </li>
            ))
          ) : (
            <li className="list-group-item text-muted">Sin resultados</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;